import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import CollapsibleSidebar from './CollapsibleSidebar';

const SettingsSidebar = ({ currentPage = 'account', onPageChange }) => {
  const { palette } = useTheme();

  const menuItems = [
    { id: 'account', label: 'Account Information' },
    { id: 'preferences', label: 'Preferences' },
    { id: 'schedule', label: 'Schedule Settings' },
  ];

  return (
    <CollapsibleSidebar itemCount={menuItems.length}>
      <View style={styles.sidebarList}>
        {menuItems.map((item) => {
          const isActive = currentPage === item.id;
          return (
            <TouchableOpacity
              key={item.id}
              style={[
                styles.sidebarItem,
                isActive && styles.activeItem
              ]}
              onPress={() => onPageChange && onPageChange(item.id)}
            >
              <Text
                style={[
                  styles.sidebarText,
                  isActive && styles.sidebarTextActive
                ]}
              >
                {item.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </CollapsibleSidebar>
  );
};

const styles = StyleSheet.create({
  sidebarList: {
    gap: 8,
    paddingHorizontal: 16,
  },
  sidebarItem: {
    alignSelf: 'stretch',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    minHeight: 40,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      },
    }),
  },
  activeItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    ...Platform.select({
      web: {
        boxShadow: '2px 3px 0px rgba(0,0,0,0.8)',
      },
    }),
  },
  sidebarText: {
    flex: 1,
    fontSize: 15,
    fontFamily: 'Public Sans',
    fontWeight: '500',
    color: 'white',
    ...Platform.select({
      web: {
        textShadow: '1px 1px 0px rgba(0,0,0,0.8)',
      },
    }),
  },
  sidebarTextActive: {
    fontWeight: '700',
    color: '#000000',
    ...Platform.select({
      web: {
        textShadow: 'none',
      },
    }),
  },
});

export default SettingsSidebar;

